import { render, staticRenderFns } from "./CustomRatingTableOperation.vue?vue&type=template&id=00c59246&"
import script from "./CustomRatingTableOperation.vue?vue&type=script&lang=js&"
export * from "./CustomRatingTableOperation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports